<template>
  <div class="row">
    <div class="title">{{ title }}</div>
    <div class="content" v-html="content"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EXArticle',
  props: {
    title: String,
    content: String,
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  color: #333;
  font-weight: 500;
  line-height: .5rem;
  &::before {
    content: "";
    background: #333;
    display: inline-block;
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 50%;
    margin-right: 0.05rem;
  }
}
.content {
  line-height: .3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/EXArticle/index.vue